import React, {useState, Fragment, useEffect} from 'react';
import axios from 'axios';
import styles from  './passports.module.scss'; 
import Select, {components} from 'react-select';
import { useIsMobile900 } from '../../hooks/mobile';
import { getNumberWithOrdinalWithSuperscript, percentFormat, percentFormatThreeDecimal, sortDataByName } from '../../utils/utils';
import CountryFlag from '../common/countryFlag/country-flag';
import ProgressBar from '../common/progressBar/progress-bar.module';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import IconGlobal from '../common/icon/icon-global';
import IconSearch from '../common/icon/icon-search';
import IconDelete from '../common/icon/icon-delete';
import PopUpList from '../common/popupList/popup-list';
import LoadingSpinner from '../common/loading/LoadingSpinner';
import { getSourceURL } from '../../config/config';


const options = [
    {label:"Economic Mobility Score (Visa-Free Access to Global GDP)", value:"hpp_rank"},
    {label:"Country GDP (% of Global GDP)", value:"gdp_rank"},
    {label:"Global Visa-Free Access (Out of 226 Destinations)", value:"hpi_rank"},
];

const radioBoxData = [
    { value: 'passport', label: 'PASSPORT' },
    { value: 'compare', label: 'COMPARE' },
    { value: 'cbi', label: 'CITIZENSHIP BY INVESTMENT COUNTRIES' },
    { value: 'rbi', label: 'RESIDENCE BY INVESTMENT COUNTRIES' },
    // { value: 'g20', label: 'G20 COUNTRIES' },
    
];

const dropDownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <IconSearch />
        </components.DropdownIndicator>
      )
    );
};


const Passports = () =>{
    const [data, setData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [sortColumn, setSortColumn] = useState("hpp_rank");
    const [showPopUp, setShowPopUp] = useState(false);
    const [popUpContent, setPopUpContent] = useState('');
    const [passportSelected, setPassportSelected] = useState("");
    // const [passportOptions, setPassportOptions] = useState("");
    const [tableSelectedStatus, setTableSelectedStatus] = useState(false);
    const [tableCodeSelected, setTableCodeSelected] = useState('');
    const [loading, setLoading] = useState(true);
    const isMobile = useIsMobile900();

    const [radioboxSelected, setRadioboxSelected] = useState(radioBoxData[0].value);
    const [menuTitle, setMenuTitle] = useState(radioBoxData[0].label);
    const [menuOpen, setMenuOpen] = useState(false);

    // console.log(linkData)

    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get(getSourceURL() + 'v2/hpp');
            // console.log(response.data);
            setData(response.data);
            setTableData(response.data);
            setLoading(false);

          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
    
        fetchData();
    }, []);


    const passportSelectStyles = {
        menu: (provided) => ({
          ...provided,
          zIndex: 100,
          backgroundColor:'#fff',
          borderRadius: 0,
          paddingLeft: 10,
          paddingRight: 10
        }),
        control: (provided) => ({
          ...provided,
          background: "transparent",
          border: "none",
          boxShadow: "none",
          borderRadius: 0,
          color: "#405363",
          padding:0,
          borderBottom: "1px solid #979797"
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: "#405363",
          padding: isMobile ? 14 : 12,
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "#405363",
          fontFamily: "Garamond Regular",
          fontSize: isMobile ? 14: 16,
        //   paddingLeft: 16,
        }),
        indicatorSeparator: (provided) => ({
          ...provided,
          display: "none",
        }),
        singleValue: (provided) => ({
          ...provided,
          color: "#405363",
          fontFamily: "Garamond Regular",
          fontSize: isMobile ? 14 : 16,
        //   paddingLeft: 10,
        }),
        valueContainer: (provided) => ({
          ...provided,
          padding: "0 0 8px 0",
          
        }),
        indicatorsContainer: (provided) => ({
          ...provided,
          background: "#f7f7f7",
        }),
        option: (provided, state) => ({
          ...provided,
          fontSize: isMobile ? 14 : 18,
          backgroundColor: state.isFocused
            ? "#C1C5C8"
            : state.isDisabled
            ? "#f3f3f3"
            : null,
          color: state.isFocused
            ? "#405363"
            : state.isDisabled
            ? "#405363"
            : "",
          opacity: state.isDisabled
            ? "0.5"
            : "1",
          cursor: state.isDisabled
            ? 'not-allowed'
            : 'pointer'
        }),
    };
    

    const tableRowData = (item, index) =>{
      
        let rank = '';

        if(sortColumn === 'hpp_rank'){
            rank = item.hpp_rank;
        }else if(sortColumn === 'hpi_rank'){
            rank = item.hpi_rank;
        }else if(sortColumn === 'gdp_rank'){
            rank = item.gdp_rank;
        }

        return (
            <Fragment key={index}>
                                <tr className={`${styles.contentRow} ${radioboxSelected !== 'compare' && item.code === tableCodeSelected ? styles.selectedRow : ''}
                                `}>

                                    <td className={styles.mobileLeftColumn}>
                                        <div className="d-flex align-items-center">
                                            {radioboxSelected === "compare" || tableSelectedStatus === true ? (
                                                <button className={styles.deleteRowButton} onClick={() => handleDeleteFromTable(item.code)}>
                                                    <IconDelete />
                                                </button>
                                            ):''}
                                            {radioboxSelected !== "compare" && (
                                                <span className={styles.ranking}>
                                                    {getNumberWithOrdinalWithSuperscript(rank)}
                                                </span>
                                            )}
                                            
                                            <CountryFlag country={item.name} code={item.code}/>
                                        </div>
                                    </td>
                                    <td className={`${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'hpp_rank'? styles.selectedColumn: ''}`}>                  
                                        <ProgressBar 
                                            percentValue={percentFormat(item.hpp)} 
                                            labelText={percentFormat(item.hpp) + "%"} 
                                        />
                                    </td>
                                    <td className={`text-center ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'gdp_rank'? styles.selectedColumn: ''}`}>
                                        
                                        {percentFormatThreeDecimal(item.gdp) + '%'}
                                    </td>
                                    <td className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'hpi_rank'? styles.selectedColumn: ''}`}>
                                        <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between text-nowrap">
                                            <span 
                                                onClick={(event) => handlePopUpOpen(event, item)}
                                                className={styles.visaFreeCount}>
                                                {item.hpi_score} destinations
                                            </span>
                                            <span className={styles.globalPercent}><IconGlobal /><span className="ml-2">{Math.round(item.hpi_score / 226 * 100) + '%'}</span></span>
                                        </div>
                                    </td>
                                    {/* <td className={`text-right ${styles.cellHideMobile}`}>
                                        {linkData[item.code] && (
                                            <a href={linkData[item.code]} target="_blank" className={styles.linkText} rel="noreferrer">Find out more</a>
                                        )}
                                        
                                    </td> */}
                                </tr>
            </Fragment>
        )
    }

    const sortTableData = (data, sortColumn) =>{
        return data.sort((a, b) => a[sortColumn] - b[sortColumn]);
    }
 

    const handleRadioboxChange = (event) =>{
        setRadioboxSelected(event.target.value);
        setMenuOpen(false);
        setSortColumn("hpp_rank");
    
        let selectedRadioData = radioBoxData.filter((item) => item.value === event.target.value);
        // console.log(selectedRadioData);
        setMenuTitle(selectedRadioData[0].label);

        setTableSelectedStatus(false);

        if(event.target.value === "passport"){
            setTableData(data);
            
        }else if(event.target.value === "rbi"){
            setTableData(data.filter((passport) => passport.flags.is_rbi));
        }else if(event.target.value === "cbi"){
            setTableData(data.filter((passport) => passport.flags.is_cbi));
        }else if(event.target.value === "g20"){
            setTableData(data.filter((passport) => passport.flags.is_top_gdp));
        }else if(event.target.value === "compare"){
            setTableData([]);
            setPassportSelected("");
        }  
    }
    
    const handleMenuOpen = () =>{
        setMenuOpen(!menuOpen);
    }

    const handleOptionSelect = (option) => {
        // setSelectedOption(option);
        setSortColumn(option.value);
    };

    const handleSort = (columnName) => {
        setSortColumn(columnName);
    };

    const handlePopUpOpen = (event, data) =>{
        setPopUpContent(data);
        setShowPopUp(true);
    }


    const handlePopUpClose = () =>{
        setShowPopUp(false);
    }

    const handlePassportSelect = (selectedOption) =>{
        setPassportSelected(selectedOption);
       
        if(selectedOption){
            const selectedPassportData = data.find(
                (passport) => passport.code === selectedOption.value
            );
            if(radioboxSelected === "compare"){
                if (selectedPassportData) {
                    setTableData([...tableData, selectedPassportData]);
                    setPassportSelected("");
                }
            }else{
                // setTableData([selectedPassportData]);
                setTableCodeSelected(selectedOption.value);
                setTableSelectedStatus(true);
            }
        }
    }

    const handleDeleteFromTable = (code) => {
        if(radioboxSelected === "compare"){
            const updatedTableData = tableData.filter(
                (passport) => passport.code !== code
            );
            setTableData(updatedTableData);
            setPassportSelected("");
        }else{
            // setTableData(data);
            setTableSelectedStatus(false);
            setTableCodeSelected('');
        }
    };

    const handlePassportSelectBlur = () =>{
        setPassportSelected("");
    }

    const getDisabledOptions = () => {
        return tableData.map((passport) => passport.code);
    };

    const passportOptions = () =>{
        let optionData = [];
        if(radioboxSelected === 'passport' || radioboxSelected === 'compare' ){
            optionData = data;
        }else if(radioboxSelected === 'rbi'){
            optionData = data.filter((passport) => passport.flags.is_rbi);
        }else if(radioboxSelected === 'cbi'){
            optionData = data.filter((passport) => passport.flags.is_cbi);
        }else if(radioboxSelected === 'g20'){
            optionData = data.filter((passport) => passport.flags.is_top_gdp);
        }
        return sortDataByName(optionData).map((passport)=>({
            label: passport.name, 
            value: passport.code,
            // isDisabled: type === 'compare' ? getDisabledOptions().includes(passport.code) : false
            isDisabled: radioboxSelected === 'compare' ? getDisabledOptions().includes(passport.code) : false
        }));
    }

    if (loading) return <LoadingSpinner />;


    return( 
        <>  
            <div className={`mobileMenuWrapper mb-md-5 ${menuOpen ? "menuOpen": ""}`}>
                <button className="mobileMenuToggle" onClick={handleMenuOpen}>
                <div className="mobileMenuTitleText">{menuTitle}</div>

                <div className='dropdownIcon'>
                    
                    <svg width="14px" height="6px" viewBox="0 0 14 6">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g transform="translate(-368.000000, -22.000000)" stroke="#405363">
                                <polyline points="381 22 375 28 369 22"></polyline>
                            </g>
                        </g>
                    </svg>
                </div>
                </button>
                <div className="custom-radiobox-group" style={{'maxWidth': '100%'}}>
                    {radioBoxData.map((radioBox, index) => (
                        <label className="custom-radiobox" key={index}>
                        <input type="radio" value={radioBox.value} name="radio" checked={radioboxSelected === radioBox.value} onChange={handleRadioboxChange} /> 
                        <span className="label-text">{radioBox.label}</span>
                        </label>
                    ))}
                </div>
            </div>

            <div className={`d-md-none ${styles.sortMobileWrapper}`}>
                <div className={styles.sortTitle}>Sort by</div>
                <SelectDropdown options={options} onSelect={handleOptionSelect} />
            </div>
  
            {sortColumn === "hpi_rank" && (
            <div className={`d-md-none ${styles.noteMobile}`}>
                <IconGlobal /> Travel visa free % of the world
            </div>
            )}
            <div className={styles.tableWrapper}>
                <table className={`chartTable ${styles.dataTable} ${tableSelectedStatus === true ? styles.dataTableOnSelected :''}`}>
                    <thead>
                        <tr className={styles.hideMobile}>
                            <th><h4>Passport</h4></th>
                            <th className="text-center" colSpan="2">
                                <h4>Henley Passport Power</h4>
                            </th>
                            <th  className="text-center"><h4>Henley Passport Index</h4></th>
                            {/* <th></th> */}
                        </tr>
                        <tr>
                            <th className={styles.selectBoxWrapper} width="22%">
                                <Select
                                        value={passportSelected}
                                        options={passportOptions()}
                                        onChange={handlePassportSelect}
                                        onBlur={handlePassportSelectBlur}
                                        isClearable
                                        isSearchable
                                        // menuIsOpen
                                        placeholder="Search for a passport"
                                        components={{ DropdownIndicator:dropDownIndicator}}
                                        blurInputOnSelect={true}
                                        // isOptionDisabled={(option) => option.isDisabled}
                                        styles={passportSelectStyles}
                                />
                            </th>
                            <th className={styles.mobileCell}></th>
                            <th 
                                className={`no-border-right ${styles.hideMobile}  ${styles.sortableColumn} ${sortColumn === 'hpp_rank'? styles.selectedColumn: ''}`}
                                onClick={() => handleSort("hpp_rank")}
                                width="30%"
                            >
                                <div className={styles.sortColumnTitle}>
                                    <span className={styles.sortColumnTitleText}>Economic Mobility Score<br />(Visa-Free Access to Global GDP)</span>
                                    <IconSort />
                                </div>
                            </th>
                            <th 
                                className={`${styles.hideMobile}  ${styles.sortableColumn} ${sortColumn === 'gdp_rank'? styles.selectedColumn: ''}`}
                                onClick={() => handleSort("gdp_rank")}
                                width="12%"
                            >
                                <div className={styles.sortColumnTitle}>
                                    <span className={styles.sortColumnTitleText}>Country GDP<br />(% of Global GDP)</span>
                                    <IconSort />
                                </div>
                            </th>
                            <th 
                                className={`${styles.hideMobile}  ${styles.sortableColumn} ${sortColumn === 'hpi_rank'? styles.selectedColumn: ''}`}
                                onClick={() => handleSort("hpi_rank")}
                                width="18%"
                            >   
                                <div className="d-flex align-items-end justify-content-between">
                                    <div className={styles.sortColumnTitle}>
                                        <span className={styles.sortColumnTitleText}>Global Visa-Free Access<br />(Out of 226 Destinations)</span>
                                        <IconSort />
                                    </div>

                                    <span className="text-right">Visa-Free Travel<br />(% of the World)</span>
                                </div>
                            </th>
                            
                        </tr>
                    </thead>

                    <tbody className={styles.mainDataBody}>
                      
                        {sortTableData(tableData, sortColumn).map((item, index) => (
                            tableRowData(item, index)
                        ))}
                    </tbody>
     
                    
                </table>
                
                {showPopUp && <PopUpList data={popUpContent} onClose={handlePopUpClose} /> }
                
            </div>
        </>
    )
}

export default Passports;